import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const assistantsList = [
  {
    account_id: 2,
    config: { product_name: 'SiteUP CRM' },
    created_at: 1736033561,
    description:
      'An advanced AI assistant designed to enhance customer support solutions by automating workflows and providing instant responses.',
    id: 4,
    name: 'Assistente de suporte',
  },
  {
    account_id: 3,
    config: { product_name: 'SiteUP CRM' },
    created_at: 1736033562,
    description:
      'Helps streamline customer relationship management by organizing contacts, automating follow-ups, and providing insights.',
    id: 5,
    name: 'Assistente comercial',
  },
  {
    account_id: 4,
    config: { product_name: 'SiteUP CRM' },
    created_at: 1736033563,
    description:
      'Optimizes your sales pipeline by tracking prospects, forecasting sales, and automating administrative tasks.',
    id: 6,
    name: 'Assistente de vendas',
  },
  {
    account_id: 5,
    config: { product_name: 'SiteUP CRM' },
    created_at: 1736033564,
    description:
      'Automates ticket assignment, categorization, and customer query responses to enhance support efficiency.',
    id: 7,
    name: 'Assistente de triagem',
  },
  {
    account_id: 6,
    config: { product_name: 'SiteUP CRM' },
    created_at: 1736033565,
    description:
      'Provides financial analytics, reporting, and insights, helping teams make data-driven financial decisions.',
    id: 8,
    name: 'Assistente financeiro',
  },
  {
    account_id: 8,
    config: { product_name: 'SiteUP CRM' },
    created_at: 1736033567,
    description:
      'Streamlines HR operations including employee management, payroll, and recruitment processes.',
    id: 10,
    name: 'Assistente de equipe',
  },
];

export const documentsList = [
  {
    account_id: 1,
    assistant: { id: 1, name: 'Helper Pro' },
    content:
      'Comprehensive guide on using conversation filters to manage chats effectively.',
    created_at: 1736143272,
    external_link:
      'https://www.siteup.com.br/ajuda/primeiros-passos/usar-etiquetas-campos-personalizados',
    id: 3059,
    name: 'Organizar contatos e conversas',
    status: 'available',
  },
  {
    account_id: 2,
    assistant: { id: 2, name: 'Assistente de suporte' },
    content:
      'Guia para automatizar a distribuição de atendimentos e melhorar o fluxo da equipe no SiteUP CRM.',
    created_at: 1736143273,
    external_link:
      'https://www.siteup.com.br/ajuda/capitao/configurar-assistente-captain-copilot',
    id: 3060,
    name: 'Configurar atendimento automatizado',
    status: 'available',
  },
  {
    account_id: 3,
    assistant: { id: 3, name: 'Assistente comercial' },
    content:
      'A detailed guide on managing and organizing customer profiles for better relationship management.',
    created_at: 1736143274,
    external_link:
      'https://www.siteup.com.br/ajuda/contatos/criar-editar-contato',
    id: 3061,
    name: 'Gerenciar perfis de clientes',
    status: 'available',
  },
  {
    account_id: 4,
    assistant: { id: 4, name: 'Assistente de vendas' },
    content:
      'Learn how to optimize sales tracking and improve your sales forecasting using advanced features.',
    created_at: 1736143275,
    external_link: 'https://www.siteup.com.br/ajuda/kanban/visao-geral',
    id: 3062,
    name: 'Acompanhar oportunidades no Kanban',
    status: 'available',
  },
  {
    account_id: 5,
    assistant: { id: 5, name: 'Assistente de triagem' },
    content:
      'Como criar, acompanhar e resolver atendimentos com eficiência no SiteUP CRM.',
    created_at: 1736143276,
    external_link:
      'https://www.siteup.com.br/ajuda/primeiros-passos/quickstart-30-minutos',
    id: 3063,
    name: 'Começar no SiteUP CRM',
    status: 'available',
  },
  {
    account_id: 6,
    assistant: { id: 6, name: 'Assistente financeiro' },
    content:
      'Detailed guide on how to use financial reporting tools and generate insightful analytics.',
    created_at: 1736143277,
    external_link: 'https://www.siteup.com.br/ajuda/relatorios/visao-geral',
    id: 3064,
    name: 'Ler os relatórios da operação',
    status: 'available',
  },
];

export const responsesList = [
  {
    account_id: 1,
    answer:
      'Verifique o plano contratado e o limite de caixas antes de conectar o canal.',
    created_at: 1736283330,
    id: 87,
    question: 'Como conectar um canal de atendimento?',
    status: 'pending',
    assistant: {
      account_id: 1,
      config: { product_name: 'SiteUP CRM' },
      created_at: 1736033280,
      description: 'Assists with general queries and system-wide issues.',
      id: 1,
      name: 'Assistente de canais',
    },
  },
  {
    account_id: 2,
    answer:
      'Abra Integrações, selecione WhatsApp e siga as etapas de conexão da sua conta.',
    created_at: 1736283340,
    id: 88,
    question: 'Como integrar WhatsApp ao atendimento?',
    assistant: {
      account_id: 2,
      config: { product_name: 'SiteUP CRM' },
      created_at: 1736033281,
      description: 'Helps with integration and setup-related inquiries.',
      id: 2,
      name: 'Assistente de integrações',
    },
  },
  {
    account_id: 3,
    answer:
      'Abra a tela de acesso, selecione esqueci minha senha e siga as instruções enviadas por e-mail.',
    created_at: 1736283350,
    id: 89,
    question: 'Como redefinir minha senha?',
    assistant: {
      account_id: 3,
      config: { product_name: 'SiteUP CRM' },
      created_at: 1736033282,
      description: 'Handles account management and recovery support.',
      id: 3,
      name: 'Assistente de acesso',
    },
  },
  {
    account_id: 4,
    answer: 'Ative o modo escuro em Aparência nas configurações do painel.',
    created_at: 1736283360,
    id: 90,
    question: 'Como ativar o modo escuro?',
    assistant: {
      account_id: 4,
      config: { product_name: 'SiteUP CRM' },
      created_at: 1736033283,
      description: 'Helps with UI and theme-related inquiries.',
      id: 4,
      name: 'Assistente de configuração',
    },
  },
  {
    account_id: 5,
    answer:
      'Abra Configurações, acesse Equipe e envie um convite para o novo atendente.',
    created_at: 1736283370,
    id: 91,
    question: 'Como convidar um atendente?',
    assistant: {
      account_id: 5,
      config: { product_name: 'SiteUP CRM' },
      created_at: 1736033284,
      description: 'Supports team management and user access-related queries.',
      id: 5,
      name: 'Assistente de equipe',
    },
  },
  {
    account_id: 6,
    answer:
      'As campanhas permitem enviar mensagens para grupos específicos de contatos. Crie uma campanha na área de Campanhas.',
    created_at: 1736283380,
    id: 92,
    question: 'Como funcionam as campanhas?',
    assistant: {
      account_id: 6,
      config: { product_name: 'SiteUP CRM' },
      created_at: 1736033285,
      description:
        'Specialized in marketing, campaign management, and messaging strategies.',
      id: 6,
      name: 'Assistente de campanhas',
    },
  },
];

export const inboxes = [
  {
    id: 7,
    name: 'Email Support',
    channel_type: INBOX_TYPES.EMAIL,
    email: 'support@company.com',
  },
  {
    id: 1,
    name: 'Website Chat',
    channel_type: INBOX_TYPES.WEB,
  },
  {
    id: 2,
    name: 'Facebook Support',
    channel_type: INBOX_TYPES.FB,
  },
  {
    id: 5,
    name: 'SMS Service',
    channel_type: INBOX_TYPES.TWILIO,
    messaging_service_sid: 'MGxxxxxx',
  },
  {
    id: 6,
    name: 'WhatsApp Support',
    channel_type: INBOX_TYPES.WHATSAPP,
    phone_number: '+1987654321',
  },
  {
    id: 8,
    name: 'Telegram Support',
    channel_type: INBOX_TYPES.TELEGRAM,
  },
  {
    id: 9,
    name: 'LINE Support',
    channel_type: INBOX_TYPES.LINE,
  },
  {
    id: 10,
    name: 'API Channel',
    channel_type: INBOX_TYPES.API,
  },
  {
    id: 11,
    name: 'SMS Basic',
    channel_type: INBOX_TYPES.SMS,
    phone_number: '+1555555555',
  },
];
